let audioCtx: AudioContext | null = null

function getAudioContext(): AudioContext | null {
  if (typeof window === 'undefined') {
    return null
  }
  const Ctor = window.AudioContext ?? (window as typeof window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext
  if (!Ctor) {
    return null
  }
  if (!audioCtx) {
    audioCtx = new Ctor()
  }
  return audioCtx
}

function playTone(ctx: AudioContext, frequency: number, startTime: number, duration: number, peakGain = 0.2): void {
  const oscillator = ctx.createOscillator()
  const gain = ctx.createGain()

  oscillator.type = 'sine'
  oscillator.frequency.setValueAtTime(frequency, startTime)

  // Fast attack + fast exponential decay gives the percussive "knock" feel instead of a lingering tone.
  gain.gain.setValueAtTime(0, startTime)
  gain.gain.linearRampToValueAtTime(peakGain, startTime + 0.008)
  gain.gain.exponentialRampToValueAtTime(0.0001, startTime + duration)

  oscillator.connect(gain)
  gain.connect(ctx.destination)

  oscillator.start(startTime)
  oscillator.stop(startTime + duration)
}

/**
 * Plays a short three-note ascending chime for incoming notifications, in the style of
 * Slack's "knock" sound — quick, percussive, rising pitch. No-op if Web Audio is unavailable or blocked.
 */
export function playNotificationSound(): void {
  const ctx = getAudioContext()
  if (!ctx) {
    return
  }

  if (ctx.state === 'suspended') {
    void ctx.resume()
  }

  const now = ctx.currentTime
  playTone(ctx, 587.33, now, 0.22, 0.6) // D5
  playTone(ctx, 880, now + 0.16, 0.24, 0.7) // A5
  playTone(ctx, 1174.66, now + 0.32, 0.38, 0.6) // D6
}
